import { toast } from 'sonner';

export interface NotifyOptions {
  description?: string;
  duration?: number;
  id?: string | number;
}

export const notify = {
  success: (message: string, options?: NotifyOptions) => {
    return toast.success(message, {
      description: options?.description,
      duration: options?.duration ?? 4000,
      id: options?.id,
    });
  },

  error: (message: string, options?: NotifyOptions) => {
    return toast.error(message, {
      description: options?.description,
      duration: options?.duration ?? 5000,
      id: options?.id,
    });
  },

  warning: (message: string, options?: NotifyOptions) => {
    return toast.warning(message, {
      description: options?.description,
      duration: options?.duration ?? 4000,
      id: options?.id,
    });
  },

  info: (message: string, options?: NotifyOptions) => {
    return toast.info(message, {
      description: options?.description,
      duration: options?.duration ?? 4000,
      id: options?.id,
    });
  },

  loading: (message: string, options?: NotifyOptions) => {
    return toast.loading(message, {
      description: options?.description,
      id: options?.id,
    });
  },

  dismiss: (id?: string | number) => {
    toast.dismiss(id);
  },
};
